import { Controller } from "@hotwired/stimulus"

// Manages the accordion behaviour within the consolidation table body.
export default class extends Controller {
  static targets = ["header"]

  connect() {
    this.headerTargets.forEach((header) => this.collapse(header))
  }

  toggle(event) {
    const header = event.currentTarget?.closest(
      "[data-consolidation-accordion-group]"
    )

    if (!header) return

    this.toggleHeader(header)
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()

      const header = event.currentTarget?.closest(
        "[data-consolidation-accordion-group]"
      )

      if (!header) return

      this.toggleHeader(header)
    }
  }

  toggleHeader(header) {
    if (!header) return

    if (this.isExpanded(header)) {
      this.collapse(header)
    } else {
      this.expand(header)
    }
  }

  expandAll() {
    this.headerTargets.forEach((header) => this.expand(header))
  }

  collapseAll() {
    this.headerTargets.forEach((header) => this.collapse(header))
  }

  expand(header) {
    const groupId = header.dataset.consolidationAccordionGroup
    if (!groupId) return

    this.setGroupVisibility(groupId, true)
    header.dataset.consolidationAccordionState = "expanded"
    header.setAttribute("aria-expanded", "true")
    header.classList.add("is-expanded")
    this.updateIndicator(header, "-")
  }

  collapse(header) {
    const groupId = header.dataset.consolidationAccordionGroup
    if (!groupId) return

    this.setGroupVisibility(groupId, false)
    header.dataset.consolidationAccordionState = "collapsed"
    header.setAttribute("aria-expanded", "false")
    header.classList.remove("is-expanded")
    this.updateIndicator(header, "+")
  }

  setGroupVisibility(groupId, shouldShow) {
    const rows = this.element.querySelectorAll(
      `[data-consolidation-accordion-row="${groupId}"]`
    )
    
    rows.forEach((row) => {
      if (shouldShow) {
        row.classList.remove("consolidation-accordion-hidden")
        row.hidden = false
        row.removeAttribute("hidden")
        row.removeAttribute("aria-hidden")
      } else {
        row.classList.add("consolidation-accordion-hidden")
        row.hidden = true
        row.setAttribute("hidden", "")
        row.setAttribute("aria-hidden", "true")
      }
    })
  }

  isExpanded(header) {
    return header?.dataset?.consolidationAccordionState === "expanded"
  }

  updateIndicator(header, symbol) {
    const indicatorText = ` ${symbol}`
    const firstCell = header?.querySelector("td, th")
    if (!firstCell) return

    const indicator = firstCell.querySelector(
      "[data-consolidation-accordion-indicator]"
    )

    if (indicator) {
      indicator.textContent = indicatorText
    } else {
      const indicatorSpan = document.createElement("span")
      indicatorSpan.dataset.consolidationAccordionIndicator = "true"
      indicatorSpan.setAttribute("aria-hidden", "true")
      indicatorSpan.textContent = indicatorText
      firstCell.append(indicatorSpan)
    }
  }
}
